import {get, post} from '@/utils/httpHelper';

export default {
  async findAllLanguage () {
    const url = `/esg/dictionary/display`;
    const body = await get(url);
    return body.data;
  },
  async findCoverPageContent (userType, language) {
    const url = `/esg/dictionary/coverPageContent/${userType}/${language}`;
    const body = await get(url);
    return body.data;
  },
  async dictionaryCacheClean () {
    const url = `/esg/security/admin/dictionary/clean`;
    const body = await get(url);
    return body.data;
  },
  async findAllDictionary () {
    const url = `/esg/security/admin/dictionary/findAllDictionary`;
    const body = await get(url);
    return body.data;
  },
  async updateDictionary (dictionary) {
    const url = `/esg/security/admin/dictionary/updateDictionary`;
    const body = await post(url, dictionary);
    return body.data;
  },
  async findDicValue (cateGory, DicKey) {
    const url = `/esg/security/auth/dictionary/findDicValue/?cateGory=${cateGory}&DicKey=${DicKey}`;
    const body = await get(url);
    return body.data;
  }
}



// WEBPACK FOOTER //
// ./src/repositories/dictionary.repository.js